module.exports = __webpack_public_path__ + "img/wx.0ef19595.jpg";